import "./signIn.css";

import React from "react";

import { Controller, useForm } from "react-hook-form";
import { useDispatch } from "react-redux";
import { loginUser } from "../../../appState/slices/auth/authSlice";
import { useNavigate } from "react-router";
import { setToastMessage } from "../../../appState/slices/util/utilSlice";
import { updateUserCart } from "../../../appState/slices/cart/cartSlice";

const SignIn = () => {
  const {
    handleSubmit,
    control,
    formState: { errors },
  } = useForm();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const onSubmit = async (data) => {
  try {
    const response = await dispatch(loginUser(data));

    if (response.error) {
      dispatch(
        setToastMessage({
          type: "error",
          message: response.error.message,
          show: true,
        })
      );
      return;
    }

    const guestCart = JSON.parse(
      localStorage.getItem("guestCart") || "[]"
    );

    for (const item of guestCart) {
      await dispatch(
        updateUserCart({
          ...item,
          operation: "add",
        })
      );
    }

    localStorage.removeItem("guestCart");

    const redirectTo =
  localStorage.getItem("redirectAfterLogin") || "/";


localStorage.removeItem("redirectAfterLogin");


    dispatch(
      setToastMessage({
        type: "success",
        message: "Login Successfully",
        show: true,
      })
    );

    navigate(redirectTo);

  } catch (error) {
    console.error(error);
  }
};
  return (
    <form onSubmit={handleSubmit(onSubmit)} className="signin-container">
      <div>
  <Controller
    name="contactInfo"
    control={control}
    defaultValue=""
    rules={{
      required: "Please enter your Email",
      pattern: {
        value:
          /^([A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}|[6-9]\d{9})$/,
        message: "Please enter a valid Email",
      },
    }}
    render={({ field }) => (
      <div className="input-container">
        <input
          type="text"
          placeholder="EMAIL"
          {...field}
        />
        {errors.contactInfo && (
          <p className="forms-error">{errors.contactInfo.message}</p>
        )}
      </div>
    )}
  />
</div>

      <div>
  <Controller
    name="password"
    control={control}
    defaultValue=""
    rules={{
      required: "Password is required",
      minLength: {
        value: 8,
        message: "Password must be at least 8 characters long.",
      },
    }}
    render={({ field }) => (
      <div className="input-container">
        <input
          placeholder="PASSWORD"
          type="password"
          {...field}
        />
        {errors.password && (
          <p className="forms-error">{errors.password.message}</p>
        )}
      </div>
    )}
  />
</div>

      {/* <div>
        <label>Phone Number</label>
        <Controller
          name="phoneNumber"
          control={control}
          defaultValue=""
          rules={{
            required: "Phone number is required",
            pattern: {
              value: /^\d{10}$/, // Assuming 10-digit phone number
              message: "Invalid phone number",
            },
          }}
          render={({ field }) => (
            <div className="input-container">
              <input type="text" {...field} />
              {errors.phoneNumber && <p>{errors.phoneNumber.message}</p>}
            </div>
          )}
        />
      </div> */}

      <button className="submit-btn" type="submit">
        Submit
      </button>
    </form>
  );
};

export default SignIn;
